import Freezeframe from 'freezeframe';

const gifs = document.querySelectorAll('.freezeframe')
gifs.forEach(item => {
    const ff = new Freezeframe(item, {
        trigger: 'click',
        overlay: true,
        responsive: true
    });
    setTimeout(() => {
        ff.start()
    }, 2000);
});
